@let isOpen = appState.chatState.isOpen$ | async;
@let isCollapsed = appState.chatState.isCollapsed$ | async;
@let canRenderIFrame = appState.chatState.canRenderIFrame$ | async;
@let unreadChatStatus = appState.chatState.unreadChatStatus$ | async;
@let chatUrl = appState.chatState.chatUrl$ | async;
@let currentChatStatus = appState.chatState.currentChatStatus$ | async;

@if (theme(); as theme) {
    <section
        class="relative right-0 bottom-[66vh] flex h-[66vh] w-400 flex-col rounded-t-2xl border-x border-t border-border-300 bg-surface-A text-text shadow transition-all"
        [attr.inert]="!isOpen ? '' : null"
        [attr.role]="isOpen ? 'dialog' : ''"
        [style.transform]="
            'translateY(' +
            (!isOpen ? '100%' : isCollapsed ? 'calc(100% - 48px)' : '0') +
            ')'
        "
        [style.transition-duration.ms]="ANIMATION_DURATION"
    >
        <header class="flex h-48 items-center justify-between gap-x-4 p-8">
            <interacta-chat-panel-header
                [currentChatStatus]="currentChatStatus"
                [isCollapsed]="isCollapsed ?? false"
                [theme]="theme.mode"
                [unreadChatStatus]="unreadChatStatus ?? 0"
            />

            <div class="flex items-center gap-x-8">
                <button
                    interacta-icon-button
                    type="button"
                    [icon]="isCollapsed ? 'chevron-big-up' : 'minus'"
                    [label]="
                        (isCollapsed
                            ? 'UI.BUTTON.MAXIMIZE'
                            : 'UI.BUTTON.MINIMIZE'
                        ) | translate
                    "
                    [size]="'small'"
                    [style]="'text'"
                    (click)="toggleCollapsed()"
                ></button>
                <button
                    interacta-icon-button
                    type="button"
                    [icon]="'fullscreen'"
                    [label]="
                        'CHAT_EMBEDDED.CHAT_PANEL.OPEN_CHAT_NEW_TAB' | translate
                    "
                    [size]="'small'"
                    [style]="'text'"
                    (click)="openChatInNewTab()"
                ></button>
                <button
                    interacta-icon-button
                    type="button"
                    [icon]="'close'"
                    [label]="'CHAT_EMBEDDED.CHAT_PANEL.CLOSE_CHAT' | translate"
                    [size]="'small'"
                    [style]="'text'"
                    (click)="close()"
                ></button>
            </div>
        </header>
        @if (chatUrl) {
            <iframe
                #chat
                class="grow"
                [attr.inert]="isCollapsed ? '' : null"
                [ngClass]="{
                    hidden: !canRenderIFrame,
                }"
                [src]="chatUrl | bypassSecurityTrust"
                [tabindex]="isCollapsed ? -1 : 0"
            ></iframe>
            @if (!canRenderIFrame) {
                <div
                    class="flex size-full flex-col items-center justify-center gap-32"
                >
                    <interacta-image
                        [alt]="'CHAT_EMBEDDED.CHAT_PANEL.ALT_LOGO' | translate"
                        [classes]="'size-152'"
                        [src]="chatLogo()"
                    />
                    <interacta-loader [size]="'large'" />
                </div>
            }
        }
    </section>
}
